var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexi-machine-right"},[_c('div',{staticClass:"game-machine-betting-component"},[_c('div',{staticClass:"game-machine-input"},[_c('ListCoins'),_c('CockXCasinoInputAmount'),_c('OutStanding'),_c('h5',[_vm._v("Statement")])],1),_c('div',{staticClass:"game-machine-statement"},[_c('Statement')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }